import { useState } from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import Pdf from "../../assets/sumanpokharel.resume.pdf";
import { Logo } from "./Logo";
import { useTheme } from "../../hooks/useTheme";

const NAV_ITEMS = [
  { num: "01", label: "about",      to: "/#home" },
  { num: "02", label: "stack",      to: "/#stack" },
  { num: "03", label: "experience", to: "/#experience" },
  { num: "04", label: "work",       to: "/#projects" },
  { num: "05", label: "logs",       to: "/#logs" },
  { num: "06", label: "contact",    to: "/#contact" },
];

export const NavBar = () => {
  const [open, setOpen] = useState(false);
  const { theme, toggle } = useTheme();

  return (
    <header className="topbar">
      {/* Row 1 — terminal titlebar */}
      <div className="titlebar">
        <div className="container titlebar__inner">
          <div className="titlebar__left">
            <span className="dots" aria-hidden="true">
              <span style={{ background: "#ff5f56" }} />
              <span style={{ background: "#ffbd2e" }} />
              <span style={{ background: "#27c93f" }} />
            </span>
            <span className="titlebar__path">~/portfolio — zsh — 124×38</span>
          </div>
          <div className="titlebar__right">
            <span className="titlebar__status">
              <span className="dot dot--green" aria-hidden="true" /> connected
            </span>
            <span className="titlebar__meta">{"{ uptime: 412d }"}</span>
            <span className="titlebar__meta">v4.2.1</span>
            <button
              type="button"
              className="themeBtn"
              onClick={toggle}
              aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
              title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
            >
              --theme=<span className="themeBtn__val">{theme}</span>
            </button>
          </div>
        </div>
      </div>

      {/* Row 2 — prompt nav */}
      <nav className={`promptnav ${open ? "is-open" : ""}`}>
        <div className="container promptnav__inner">
          <div className="promptnav__left">
            <HashLink to="/#" smooth className="promptnav__home" aria-label="Home">
              <Logo />
            </HashLink>
            <span className="promptnav__user">
              suman<span className="at">@</span>pokharel.dev:~
            </span>
          </div>

          <ul id="primary-nav" className="promptnav__items">
            {NAV_ITEMS.map((item) => (
              <li key={item.num}>
                <HashLink
                  to={item.to}
                  smooth
                  className="navItem"
                  onClick={() => setOpen(false)}
                >
                  <span className="navItem__num">{item.num}</span>
                  <span className="navItem__label">{item.label}</span>
                </HashLink>
              </li>
            ))}
            <li>
              <Link to="/blogs" className="navItem" onClick={() => setOpen(false)}>
                <span className="navItem__num">07</span>
                <span className="navItem__label">blog</span>
              </Link>
            </li>
          </ul>

          <a
            href={Pdf}
            target="_blank"
            rel="noopener noreferrer"
            className="resumeBtn"
          >
            ./resume.pdf
          </a>

          <button
            type="button"
            className={`burger ${open ? "is-open" : ""}`}
            aria-label="Toggle menu"
            aria-controls="primary-nav"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>
    </header>
  );
};
